module.exports = __webpack_public_path__ + "images/bannerDE-7a51693e629132173b28aaea068cacfe.png";